import { useQuery } from '@office-start/data-fetching';
import { bootstrapPromise } from '../bootstrapper';
export function useOfficeComponentContext() {
    var query = ['OfficeComponentContext'];
    return useQuery(query, function () { return bootstrapPromise; }, {
        cacheTime: Infinity,
        staleTime: Infinity,
    });
}
//# sourceMappingURL=useOfficeComponentContext.js.map